import Badge from "@resource/atlas/badge/Badge";
import _ from "lodash";

type FilterOption = {
  id: string;
  label: string;
};

type SelectedFiltersProps = {
  label: string;
  filterValue: string[];
  filterOptions: FilterOption[];
  clearFilter(): void;
};

function SelectedFilters({
  filterOptions,
  label,
  filterValue,
  clearFilter,
}: SelectedFiltersProps) {
  return filterValue?.length ? (
    <Badge
      isDismissible
      size="medium"
      onDismiss={() => clearFilter()}
      color="primary"
      styles="subtle"
    >
      {`${label}: ${_(filterValue)
        .map((id) => _.find(filterOptions, { id })?.label)
        .join(", ")}`}
    </Badge>
  ) : null;
}

export default SelectedFilters;
